export const FETCH_STOCK_WISE_DATA_FOR_REPORT_REQUEST_DK = 'FETCH_STOCK_WISE_DATA_FOR_REPORT_REQUEST_DK';
export const FETCH_STOCK_WISE_DATA_FOR_REPORT_SUCCESS_DK = 'FETCH_STOCK_WISE_DATA_FOR_REPORT_SUCCESS_DK';
export const FETCH_STOCK_WISE_DATA_FOR_REPORT_FAILURE_DK = 'FETCH_STOCK_WISE_DATA_FOR_REPORT_FAILURE_DK';

export const FETCH_STOCK_WISE_DATA_FOR_REPORT_FAB_REQUEST_DK = 'FETCH_STOCK_WISE_DATA_FOR_REPORT_FAB_REQUEST_DK';
export const FETCH_STOCK_WISE_DATA_FOR_REPORT_FAB_SUCCESS_DK = 'FETCH_STOCK_WISE_DATA_FOR_REPORT_FAB_SUCCESS_DK';
export const FETCH_STOCK_WISE_DATA_FOR_REPORT_FAB_FAILURE_DK = 'FETCH_STOCK_WISE_DATA_FOR_REPORT_FAB_FAILURE_DK';

export const FETCH_STOCK_WISE_DATA_FOR_REPORT_ACC_REQUEST_DK = 'FETCH_STOCK_WISE_DATA_FOR_REPORT_ACC_REQUEST_DK';
export const FETCH_STOCK_WISE_DATA_FOR_REPORT_ACC_SUCCESS_DK = 'FETCH_STOCK_WISE_DATA_FOR_REPORT_ACC_SUCCESS_DK';
export const FETCH_STOCK_WISE_DATA_FOR_REPORT_ACC_FAILURE_DK = 'FETCH_STOCK_WISE_DATA_FOR_REPORT_ACC_FAILURE_DK';

export const SET_TAB_NAME_DATA = 'SET_TAB_NAME_DATA';

// ******* Stock Reports CP ******* //
export const FETCH_STOCK_REPORT_CP_DATA_REQUEST = 'FETCH_STOCK_REPORT_CP_DATA_REQUEST';
export const FETCH_STOCK_REPORT_CP_DATA_SUCCESS = 'FETCH_STOCK_REPORT_CP_DATA_SUCCESS';
export const FETCH_STOCK_REPORT_CP_DATA_FAILURE = 'FETCH_STOCK_REPORT_CP_DATA_FAILURE';

export const SET_CP_TAB_NAME_DATA = 'SET_CP_TAB_NAME_DATA';